module.exports = __webpack_public_path__ + "static/image/main/card/image-9.ver2_0_2.png?3d0b6a27";